module.exports = __webpack_public_path__ + "static/media/ai_ml.f8704c65.jpg";